// text_task always opens the lesson body with `# {title}` (backend
// `prepend_title_heading` strips any H1 the LLM wrote and prepends its own),
// while TextLessonHeader already renders the title above the prose. Rendering
// both showed the title twice, so drop that one leading H1. Only the first
// line is touched - an H1 later in the body is real content and stays.
const LEADING_H1_RE = /^\s*#[ \t]+[^\n]*(?:\n+|$)/;

export function stripTitleHeading(markdown: string): string {
  return markdown.replace(LEADING_H1_RE, '');
}
